import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Tab,
  Select,
  Tooltip,
} from "@mui/material";
import SwitchToggle from "../../components/SwitchToggle";
import SearchBar from "../../components/SearchBar";
import AddPreferredPartner from "../../Modals/addpreferredpartner";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import HistoryIcon from "@mui/icons-material/History";
import AssessmentIcon from "@mui/icons-material/Assessment";
import SettingsIcon from "@mui/icons-material/Settings";
import WarningIcon from "@mui/icons-material/Warning";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import InfoIcon from "@mui/icons-material/Info";
import {
  Button,
  Typography,
  LinearProgress,
  Chip,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
} from "@mui/material";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const ViewVendorSubscription = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [openUpgradeModal, setOpenUpgradeModal] = useState(false);
  const [changeType, setChangeType] = useState<"upgrade" | "downgrade">(
    "upgrade",
  );
  const [selectedPlan, setSelectedPlan] = useState("");
  const [changeReason, setChangeReason] = useState("");

  const subscriptionDetails = {
    vendorName: "Fashion House Dubai",
    subscriptionType: "Premium",
    planName: "Scale+",
    status: "Active",
    billingCycle: "Annual",
    startDate: "01 Jan 2025",
    endDate: "31 Dec 2025",
    monthlyPrice: "AED 2,500",
    commission: "8%",
    features: [
      "Unlimited products",
      "Advanced AI Analytics",
      "Priority support",
      "AI Multi-channel Management",
    ],
  };

  const usageBreakdown = [
    { feature: "AI Product Descriptions", used: 450, limit: 500, type: "AI" },
    { feature: "AI Customer Chat", used: 1200, limit: 1000, type: "AI" },
    {
      feature: "Smart Inventory Alerts",
      used: 80,
      limit: 100,
      type: "Additional",
    },
    {
      feature: "Image Background Removal",
      used: 1500,
      limit: 2000,
      type: "Additional",
    },
  ];

  const subscriptionHistory = [
    {
      plan: "Scale+",
      type: "Upgrade",
      dates: "01 Jan 2025 - 31 Dec 2025",
      billing: "Annual",
      status: "Active",
      initiatedBy: "Admin (Sarah)",
      reason: "High volume vendor eligibility",
    },
    {
      plan: "Pro",
      type: "Subscription",
      dates: "01 Jan 2024 - 31 Dec 2024",
      billing: "Monthly",
      status: "Expired",
      initiatedBy: "Vendor",
      reason: "Initial plan",
    },
  ];

  const addons = [
    {
      name: "Extra AI Credits (500)",
      purchasedDate: "15 Jan 2025",
      status: "Active",
    },
    {
      name: "Premium Support Pack",
      purchasedDate: "05 Jan 2025",
      status: "Active",
    },
  ];

  const handleOpenPlanChange = (type: "upgrade" | "downgrade") => {
    setChangeType(type);
    setOpenUpgradeModal(true);
  };

  return (
    <div className="subscription_management_wrapper">
      <div className="main_title">
        <h1>Subscription Details</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-vendors/view-vendor")}>
            View Vendor
          </button>{" "}
          - View Subscription
        </p>
      </div>
      <Box className="custom_tabs1" sx={{ width: "100%" }}>
        <Tabs
          value={valueTabs}
          onChange={handleChangeTabs}
          aria-label="basic tabs example"
          className="custom_tabs_links"
        >
          <Tab label="Subscription Details" {...a11yProps(0)} />
          <Tab label="Feature Usage Breakdown" {...a11yProps(1)} />
          <Tab label="Subscription History" {...a11yProps(2)} />
          <Tab label="Billing & Credits" {...a11yProps(3)} />
        </Tabs>
      </Box>

      <CustomTabPanel value={valueTabs} index={0}>
        <div className="d_flex gap_20">
          <div className="cards w_60">
            <div className="d_flex justify-between align-center mb_20">
              <h3>Current Plan: {subscriptionDetails.planName}</h3>
              <span className={`status_chip active`}>
                {subscriptionDetails.status}
              </span>
            </div>
            <div className="view_page">
              <div className="gap_p">
                <div className="w_50">
                  <h6>Start Date</h6>
                  <p>{subscriptionDetails.startDate}</p>
                </div>
                <div className="w_50">
                  <h6>End Date</h6>
                  <p>{subscriptionDetails.endDate}</p>
                </div>
                <div className="w_50">
                  <h6>Billing Cycle</h6>
                  <p>{subscriptionDetails.billingCycle}</p>
                </div>
                <div className="w_50">
                  <h6>Price</h6>
                  <p>{subscriptionDetails.monthlyPrice}</p>
                </div>
                <div className="w_100">
                  <h6>Enabled Features</h6>
                  <ul className="inline_tags">
                    {subscriptionDetails.features.map((f, i) => (
                      <li key={i}>{f}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="cards w_40">
            <h3>Plan Actions</h3>
            <p className="text_grey mb_20">
              Change or manage vendor's subscription plan directly.
            </p>
            <div className="btn_flex vertical gap_10">
              <Button
                fullWidth
                variant="contained"
                color="primary"
                startIcon={<TrendingUpIcon />}
                onClick={() => handleOpenPlanChange("upgrade")}
              >
                Upgrade Plan
              </Button>
              <Button
                fullWidth
                variant="outlined"
                color="warning"
                startIcon={
                  <TrendingUpIcon sx={{ transform: "rotate(180deg)" }} />
                }
                onClick={() => handleOpenPlanChange("downgrade")}
              >
                Downgrade Plan
              </Button>
              <Button
                fullWidth
                variant="outlined"
                color="error"
                startIcon={<SettingsIcon />}
              >
                Lock Plan Changes
              </Button>
            </div>

            <div className="ai_alert success mt_20">
              <div className="d_flex align-center">
                <SmartToyIcon sx={{ mr: 1 }} />
                <Typography variant="body2">
                  <b>AI Recommendation:</b> Vendor's high usage of AI chips
                  suggests an upgrade to <b>Enterprise</b> would be 15% more
                  cost-effective.
                </Typography>
              </div>
            </div>
          </div>
        </div>
      </CustomTabPanel>

      <CustomTabPanel value={valueTabs} index={1}>
        <div className="cards">
          <div className="d_flex justify-between align-center mb_25">
            <div>
              <h3 className="m_0">Feature Usage Metrics</h3>
              <p className="text_grey m_0" style={{ fontSize: "0.85rem" }}>
                Real-time monitoring of resource allocation and limits.
              </p>
            </div>
            <Button
              variant="outlined"
              size="small"
              startIcon={<AssessmentIcon />}
            >
              Generate Report
            </Button>
          </div>

          <div className="mt_20 gap_25 d_flex flex_wrap">
            {usageBreakdown.map((item, i) => {
              const percentage = (item.used / item.limit) * 100;
              const isNearLimit = percentage >= 80 && percentage < 100;
              const isOverLimit = percentage >= 100;

              return (
                <div key={i} className="usage_modern_card w_48">
                  <div className="usage_header">
                    <div className="usage_title_group">
                      <div
                        className={`usage_icon_circle ${item.type === "AI" ? "ai_bg" : "default_bg"}`}
                      >
                        {item.type === "AI" ? (
                          <SmartToyIcon fontSize="small" />
                        ) : (
                          <SettingsIcon fontSize="small" />
                        )}
                      </div>
                      <Typography variant="subtitle1" className="usage_name">
                        <b>{item.feature}</b>
                      </Typography>
                    </div>
                    <Chip
                      label={item.type}
                      size="small"
                      className={`usage_type_chip ${item.type === "AI" ? "ai_chip" : ""}`}
                    />
                  </div>

                  <div className="usage_body">
                    <div className="d_flex justify-between align-end mb_8">
                      <div className="usage_numbers">
                        <span className="current_val">
                          {item.used.toLocaleString()}
                        </span>
                        <span className="limit_val">
                          {" "}
                          / {item.limit.toLocaleString()} Units
                        </span>
                      </div>
                      <div
                        className={`usage_percentage ${isOverLimit ? "text_danger" : isNearLimit ? "text_warning" : "text_primary"}`}
                      >
                        {percentage.toFixed(0)}%
                      </div>
                    </div>

                    <Box sx={{ position: "relative", width: "100%" }}>
                      <div className="progress_track_modern">
                        <div
                          className={`progress_bar_modern ${isOverLimit ? "bg_danger" : isNearLimit ? "bg_warning" : "bg_primary"}`}
                          style={{ width: `${Math.min(percentage, 100)}%` }}
                        ></div>
                      </div>
                      {isOverLimit && (
                        <Tooltip title="Limit exceeded! Throttling active.">
                          <WarningIcon className="limit_warning_icon" />
                        </Tooltip>
                      )}
                    </Box>

                    {isNearLimit && !isOverLimit && (
                      <div className="usage_footer_alert warning">
                        <InfoIcon sx={{ fontSize: 14 }} />
                        <span>Approaching limit. Consider upgrading.</span>
                      </div>
                    )}
                    {isOverLimit && (
                      <div className="usage_footer_alert danger">
                        <WarningIcon sx={{ fontSize: 14 }} />
                        <span>Limit exceeded. Feature throttled.</span>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </CustomTabPanel>

      <CustomTabPanel value={valueTabs} index={2}>
        <div className="cards">
          <div className="d_flex justify-between align-center mb_20">
            <h3>Subscription History</h3>
            <div className="form">
              <input type="date" placeholder="Filter by date" />
            </div>
          </div>
          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Plan Name</TableCell>
                  <TableCell>Action Type</TableCell>
                  <TableCell>Duration</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Initiated By</TableCell>
                  <TableCell>Reason</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {subscriptionHistory.map((row, i) => (
                  <TableRow key={i}>
                    <TableCell>
                      <b>{row.plan}</b>
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={row.type}
                        size="small"
                        color={row.type === "Upgrade" ? "success" : "default"}
                      />
                    </TableCell>
                    <TableCell>{row.dates}</TableCell>
                    <TableCell>
                      <span
                        className={`status_chip ${row.status.toLowerCase()}`}
                      >
                        {row.status}
                      </span>
                    </TableCell>
                    <TableCell>{row.initiatedBy}</TableCell>
                    <TableCell>{row.reason}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <h3 className="mt_30 mb_20">Active Add-ons</h3>
          <div className="d_flex gap_20">
            {addons.map((addon, i) => (
              <div
                key={i}
                className="cards"
                style={{ border: "1px solid #e2e8f0", flex: 1 }}
              >
                <div className="d_flex justify-between align-center">
                  <Typography variant="h6">{addon.name}</Typography>
                  <span className="status_chip active">{addon.status}</span>
                </div>
                <p className="text_grey mt_5">
                  Purchased on: {addon.purchasedDate}
                </p>
              </div>
            ))}
          </div>
        </div>
      </CustomTabPanel>

      <CustomTabPanel value={valueTabs} index={3}>
        <div className="cards">
          <h3>Billing & Credit Logs</h3>
          <p>
            Logs for financial transactions and credit consumption are available
            here.
          </p>
        </div>
      </CustomTabPanel>

      <Dialog
        open={openUpgradeModal}
        onClose={() => setOpenUpgradeModal(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ textTransform: "capitalize" }}>
          {changeType} Vendor Plan
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" className="mb_20">
            Current Plan: <b>{subscriptionDetails.planName}</b>
          </Typography>

          <div className="form">
            <div className="control_group">
              <label htmlFor="new_plan">Select New Plan</label>
              <Select
                id="new_plan"
                fullWidth
                value={selectedPlan}
                onChange={(e) => setSelectedPlan(e.target.value)}
              >
                <MenuItem value="enterprise">
                  Enterprise (Custom Pricing)
                </MenuItem>
                <MenuItem value="scale">Scale+ (AED 2,500/mo)</MenuItem>
                <MenuItem value="pro">Pro (AED 1,200/mo)</MenuItem>
              </Select>
            </div>

            <div className="control_group mt_20">
              <label htmlFor="reason_for_change">Reason for {changeType} (Required for Audit)</label>
              <TextField
                id="reason_for_change"
                fullWidth
                multiline
                rows={3}
                value={changeReason}
                onChange={(e) => setChangeReason(e.target.value)}
                placeholder="E.g., High revenue growth, manual override..."
              />
            </div>

            {selectedPlan && (
              <div
                className="ai_analysis mt_20 p_15"
                style={{ background: "#f0f9ff", borderRadius: "8px" }}
              >
                <Typography variant="subtitle2" color="primary">
                  <b>Impact Summary:</b>
                </Typography>
                <ul style={{ fontSize: "13px", marginTop: "5px" }}>
                  <li>• AI Credit limit will change from 500 to 2000 units.</li>
                  <li>• Priority Support will be enabled.</li>
                  <li>
                    • Commission rate will shift to{" "}
                    {selectedPlan === "enterprise" ? "Custom" : "6%"}.
                  </li>
                </ul>
              </div>
            )}
          </div>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setOpenUpgradeModal(false)}>Cancel</Button>
          <Button
            variant="contained"
            color={changeType === "upgrade" ? "primary" : "warning"}
            onClick={() => setOpenUpgradeModal(false)}
            disabled={!selectedPlan || !changeReason}
          >
            Confirm {changeType === "upgrade" ? "Upgrade" : "Downgrade"}
          </Button>
        </DialogActions>
      </Dialog>

      <AddPreferredPartner
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
      />
    </div>
  );
};

export default ViewVendorSubscription;
